import React, { useState, useEffect } from 'react';
import VesselAutoComplete from 'components/common/VesselAutoComplete';
import { transfer } from './utils';
import TransferAll from './TransferAll';
import Reload from './Reload';
import EmailIdInput from './EmailIdInput';
import Close from 'material-ui/svg-icons/navigation/close';
import ApprovedRejected from './ApprovedRejected';
import ParamsFilter from './ParamsFilter';

export default function Filters({ 
    selectVessel, filters, setModifySizes, forMultiTransfer,
    reloadSizes, setEmailIdFilter, clearVesselFilter, setApprovedFilter,
    setParamsFilter,
}) {
    const [currentFilters, setCurrentFilters] = useState(filters);
    const [currentMultiTransfer, setCurrentMultiTransfer] = useState(forMultiTransfer);

    const multiTransfer = () => {
        for (const current of currentMultiTransfer) {
            setTimeout(() => {
                transfer(current, setModifySizes);
            }, 30);
        }
    };

    useEffect(() => {
        setCurrentMultiTransfer([]);
        setCurrentFilters(filters);
    }, [filters]);

    useEffect(() => {
        setCurrentMultiTransfer(forMultiTransfer);
    }, [forMultiTransfer]);

    return (
        <div className='filters'>
            <div className='filters--vessel'>
                <Close 
                    id='filters--vessel__remove'
                    color={filters.vessel._id ? 'black' : 'grey'}
                    style={{ cursor: currentFilters.vessel._id ? 'pointer' : 'auto' }}
                    onClick={clearVesselFilter}
                />
                <VesselAutoComplete 
                    id='filters--vessel__input'
                    selectValue={selectVessel}
                    customValue={currentFilters.vessel && currentFilters.vessel.name}
                />
            </div>
            <EmailIdInput 
                setEmailIdFilter={setEmailIdFilter}
                currentEmailId={filters.emailId}
            />
            <ApprovedRejected 
                approved={filters.approved}
                setApprovedFilter={setApprovedFilter}
            />
            <ParamsFilter 
                setParamsFilter={setParamsFilter}
                paramsFilter={currentFilters.params}
            />
            {
                filters.vessel._id &&
                <Reload
                    reloadAction={reloadSizes}
                />
            }
            {
                filters.vessel._id &&
                    <TransferAll 
                        id='transfer-all'
                        multiTransfer={multiTransfer}
                    />
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/Filters.jsx